import { parseExtraData } from 'helpers'
import {
  URL_AGENT_APPROVAL,
  URL_DETAIL_TRANSACTION,
  URL_FULFILMENT_REPORT,
  URL_DETAIL_UTANG,
  URL_DETAIL_TAGIHAN_TALANGIN,
  URL_UTANG,
  URL_PIUTANG,
  URL_DETAIL_PIUTANG,
  URL_TRANSFER_INVENTORY
} from 'utils/pathUrl'

export const handleNotificationClick = (e, navigate, ownerUserId, dispatch, triggerReadInbox) => {
  let extraData = e?.extraData
  if (typeof extraData === 'string') {
    extraData = parseExtraData(extraData)
  }

  // Trigger read API if provided
  if (e?.id && triggerReadInbox) {
    triggerReadInbox(e.id)
  }

  if (extraData && !extraData?.block) {
    try {
      const paymentId = extraData?.escrowpaymentId || extraData?.escrowPaymentId || extraData?.orderId || extraData?.tradeShortCutId;
      const payableId = extraData?.payableId;
      const userPinjamanId = extraData?.userPinjamanId;

      if (extraData?.action === 'AGENT_CONFIRMATION_PAGE' && extraData.id) {
        navigate(`${URL_AGENT_APPROVAL}?id=${extraData.id}`)
        return true
      } else if (
        extraData?.action === 'MANUAL_PAYABLE_REQUEST' ||
        extraData?.action === 'NEW_PAYABLE_CREATED' ||
        extraData?.action === 'NEW_PAYABLE_RECEIVED'
      ) {
        navigate(URL_UTANG)
        return true
      } else if (extraData?.action === 'MANUAL_RECEIVEABLE_REQUEST') {
        if (payableId) {
          navigate(`${URL_DETAIL_PIUTANG}?id=${payableId}`)
        } else {
          navigate(URL_PIUTANG)
        }
        return true
      } else if (
        extraData?.action === 'WAREHOUSE_TRANSFER_RECEIVED' ||
        extraData?.action === 'WAREHOUSE_TRANSFER_CONFIRMED'
      ) {
        const transferId = extraData?.warehousetransferId;
        const type = extraData?.action === 'WAREHOUSE_TRANSFER_RECEIVED' ? 'in' : 'out';
        if (transferId) {
          navigate(`${URL_TRANSFER_INVENTORY}/${transferId}?type=${type}`)
        } else {
          navigate(URL_TRANSFER_INVENTORY)
        }
        return true
      } else if (extraData?.action === 'TOPUP_CONFIRMATION') {
        navigate('/uang-belanja')
        return true
      } else if (extraData?.action === 'DISBURSED') {
        navigate('/penarikan-uang')
        return true
      } else if (
        extraData?.action === 'FULFILLMENT' &&
        paymentId
      ) {
        navigate(`${URL_FULFILMENT_REPORT}/${paymentId}`)
        return true
      } else if (payableId) {
        navigate(`${URL_DETAIL_UTANG}?id=${payableId}`)
        return true
      } else if (userPinjamanId) {
        navigate(URL_DETAIL_TAGIHAN_TALANGIN, { 
          state: { 
            row: { 
              id: userPinjamanId, 
              escrowpayment: { userpinjamanId: userPinjamanId } 
            } 
          } 
        })
        return true
      } else if (paymentId) {
        let navType = 'BUY';
        
        if (extraData?.type) {
          navType = extraData.type;
        } else if (extraData?.sellerUserId) {
          navType = Number(extraData.sellerUserId) === Number(ownerUserId) ? 'SELL' : 'BUY';
        } else if (
          extraData?.action === 'EVENT_BUYER_RECEIVED_ITEM' ||
          extraData?.action === 'NEW_ORDER_RECEIVED' ||
          extraData?.action === 'TRANSACTION_ON_GOING' ||
          extraData?.action === 'ORDER_CANCELED'
        ) {
          navType = 'SELL';
        }

        navigate(`${URL_DETAIL_TRANSACTION}/${paymentId}?type=${navType}`)
        return true
      }
    } catch (error) {
      console.error('Failed to navigate via notification extraData:', error)
    }
  }
  return false
}
